import React, { useState, useEffect  } from 'react'; 
import { useAuth } from 'helpers/authContext'; 
import { register_view } from 'services/db-service';

const YouTubeEmbed = ({ url, coverImageUrl, author, permlink }) => {
  const { user,recently_viewed, updateRecentlyViewed, app_settings } = useAuth();
  const autoplaySetting = app_settings.autoplay; 
  const [isPlaying, setIsPlaying] = useState(autoplaySetting);  

  // if autoplay is enabled, count when mounting 
  useEffect(() => {
    if (autoplaySetting) {
      register_view(author, permlink, recently_viewed, updateRecentlyViewed, user);
    }
  }, [autoplaySetting]); 

  // register when clicking manually
  const handlePlay = () => {
    setIsPlaying(true);
    register_view(author, permlink, recently_viewed, updateRecentlyViewed, user); 
  };

  // Generate embed URL
  const getEmbedUrl = (youtubeUrl, autoplay) => {
    const shortMatch = youtubeUrl.match(/shorts\/([a-zA-Z0-9_-]+)/);
    const watchMatch = youtubeUrl.match(/v=([a-zA-Z0-9_-]+)/);
    const autoplayParam = autoplay ? '1' : '0';

    if (shortMatch) {
      return `https://www.youtube.com/embed/${shortMatch[1]}?autoplay=${autoplayParam}`;
    } else if (watchMatch) {
      return `https://www.youtube.com/embed/${watchMatch[1]}?autoplay=${autoplayParam}`;
    } else if (youtubeUrl.includes("youtu.be/")) {
      const parts = youtubeUrl.split("youtu.be/");
      return `https://www.youtube.com/embed/${parts[1]}?autoplay=${autoplayParam}`;
    }
    return youtubeUrl;
  };

  const embedUrl = getEmbedUrl(url, isPlaying); 

  return (
    <div
      className="video-container"
      style={{
        position: 'relative',
        width: '100%',
        height: '0',
        paddingBottom: '56.25%',
        overflow: 'hidden',
      }}
    >
      {!isPlaying && (
        <div
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundImage: `url(${coverImageUrl.replace('(', '\\(').replace(')', '\\)')})`,
            borderRadius:"10px",
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            cursor: 'pointer',
            zIndex: 10,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
          }}
          onClick={handlePlay}
        >
          <img src='/assets/img/play.png' className='play-img' />
        </div>
      )}

      {isPlaying && (
        <iframe
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
          }}
          key={embedUrl} 
          src={embedUrl}
          title="YouTube video player"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowFullScreen
        ></iframe>
      )}
    </div>
  );

};

export default YouTubeEmbed;

